




































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import * as moment from 'moment'

import { Report } from '../models/report'

import { Datasource } from '../services/datasource';

@Component
export default class ListReports extends Vue {

  // Data Placeholder
  @Prop() reports!:Report[]

  format(date:Date) {
    return moment(date).format('MMMM Do YYYY, H:mm')
  }

  @Emit('edit')
  edit(id:string) {
    // request editing page
  }

  @Emit('print')
  print(id:string) { 
    // request printing
  }

  @Emit('delete')
  del(id:string) {
    // request delete item
  }
}
